module.exports = __webpack_public_path__ + "img/phone-frame.79083fa4.png";